import { Holder } from '../trx/Holder.js';
/**
 * An observable with precedence (cost) value atttached
 */
export class Fact extends Holder {
    constructor(value, cost = undefined) {
        super(value);
        this.cost = cost;
    }
    // Make the getter public so that the value can be retrieved at any time
    get() {
        return super.get();
    }
}
/**
 * Compares two cost values.
 * Cost is the path a fact has taken in its inheritance chain. Every fact is inherited from derived to parent containers and vice-versa. Inheritance from parent→derived is called “downwards” and costs 1. Inheritance from derived→parent is called “upwards” and costs 2.
 * E.g. a fact directly known to its container has a cost of [] (empty array). If it’s inherited from the parent of a parent, it has cost of [1, 1]. If it’s inherited from another derived of the parent (a sibling, so to speak), its cost is [2, 1] (up, then down).
 * A cost of undefined means the fact is not known yet, but exists in queries ⇒ lowest precedence.
 * @param c1 the first value
 * @param c2 the second value
 * @returns `< 0` if c1 has higher precendence (lower path cost) than c2, `0` if the precedence is identical, otherwise `> 0`
 */
export function compareCost(c1, c2) {
    if (c1 === c2) {
        return 0;
    }
    // undefined is always larger than any other value
    if (c1 === undefined) {
        return Infinity;
    }
    if (c2 === undefined) {
        return -Infinity;
    }
    if (c1.length !== c2.length) {
        return c1.length - c2.length;
    }
    for (let i = 0; i < c1.length; i++) {
        if (c1[i] === c2[i]) {
            break;
        }
        return c1[i] - c2[i];
    }
    return 0;
}
